import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigAService } from 'src/app/services/config.service';
import { API_PATH } from 'src/app/utility/api-constant';
import { UtilityFunctions } from 'src/app/utility/utils';

@Injectable({
  providedIn: 'root'
})
export class PmsService {

  // api_path = API_PATH;
  api_path;

  constructor(
    private http: HttpClient,
    private _configService: ConfigAService,
    public utils: UtilityFunctions,
  ) {
    this._configService.setEnvirment(this._configService.environment)
    this.api_path = this._configService.API_PATH;
  }

  DIS_Item_Get(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Item_Get, request)
  }
  DIS_Item_Ins(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Item_Ins, request)
  }
  DIS_Item_Upd(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Item_Upd, request)
  }
  DIS_Item_Search(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Item_Search, request)
  }
  DIS_Item_Del(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Item_Del, request)
  }
  DIS_Labtype_Search(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Labtype_Search, request)
  }

  DIS_Get_Lab_type(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Get_Lab_type, request)
  }
  DIS_labtype_Ins(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_labtype_Ins, request)
  }
  DIS_labtype_Upd(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_labtype_Upd, request)
  }
  DIS_LabType_Del(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabType_Del, request)
  }

  searchOrderCreationDetails(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_Order_Mst_Search, request)
    return this.http.post(this.api_path.Class_SelForDDL_OnLocationId, request)
  }
  labDispatchDetails(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Mst_Search, request)
  }
  getStateLists(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_State_SelForDDL, request)
  }
  getSchoolTypes(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_SchoolType_SelectForDDl, request)
  }
  getSchoolList(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_School_SelectForDDl, request)
  }
  getLabLists(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Lab_List_SelectForDDl, request)
  }
  labDispatchInsert(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Mst_Ins, request)
  }
  labDispatchUpdate(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Mst_Upd, request)
  }

  getLabList(): Observable<any> {
    return this.http.post(this.api_path.PMS_LabMst_SelForDDL, {})
  }

  PMS_ItemLab_Map_Search(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_ItemLab_Map_Search, request)
  }

  PMS_ItemLab_Map_Get(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_ItemLab_Map_Get, request)
  }

  PMS_ItemLab_Map_InsUpd(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_ItemLab_Map_InsUpd, request)
  }

  PMS_ItemLab_Map_Del(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_ItemLab_Map_Del, request)
  }

  PMS_LabMst_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.PMS_LabMst_SelForDDL, {})
  }
  PMS_ItemMst_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.PMS_ItemMst_SelForDDL, {})
  }

  searchOrderCreationDetailsForIns(request): Observable<any> {
    return this.http.post(this.api_path.PMS_Order_Mst_Ins_Search, request)
  }

  getDispatchLabData(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Mst_Get, request)
  }

  deleteDispatchLabData(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Mst_Del, request)
  }

  submitOrderCreationDetails(request: any): Observable<any> {
    let pk_itemindentId = this.utils.getDecryptedValue(request?.pk_itemindentId_enc);
    console.log(pk_itemindentId);
    if (Number(pk_itemindentId) > 0) {
      return this.http.post(this.api_path.PMS_ItemIndent_Mst_Upd, request)
    } else {
      return this.http.post(this.api_path.PMS_ItemIndent_Mst_Ins, request)
    }
  }
  getOrderCreationList(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_OrderLocationList_OnOrderId_Get, request)
  }
  milestoneDetails(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_DispatchMilestone_TimeLIne_Get, request)
  }

  deleteOrderCreation(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_ItemIndent_Mst_Del, request)
  }

  DIS_Region_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.DIS_Region_SelForDDL, {})
  }

  ACM_Week_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.ACM_Week_SelForDDL, {})
  }

  DIS_Milestone_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.DIS_Milestone_SelForDDL, {})
  }
  labStatusDetailsSearch(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Lab_status_Search, request)
  }


  //Reports
  PMS_LabType_List_RptDownload(request: any): Observable<any> {
    return this.http.post(this.api_path.PMS_LabType_List_RptDownload, request)
  }

  DIS_Order_Mst_List_RptDownload(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_Order_Mst_List_RptDownload, request)
  }
  DIS_MilestoneDetails_List_RptDownload(request: any): Observable<any> {
    return this.http.post(this.api_path.DIS_MilestoneDetails_List_RptDownload, request)
  }

  DIS_State_By_Id_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.DIS_State_By_Id_SelForDDL, {})
  }
  DIS_SchoolType_By_Id_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.DIS_SchoolType_By_Id_SelForDDL, {})
  }
  DIS_School_By_Id_SelForDDL(): Observable<any> {
    return this.http.post(this.api_path.DIS_School_By_Id_SelForDDL, {})
  }
  DIS_Dispatch_Milestone_Search(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_Search, request)
  } 
  DIS_MilestoneDetails_Get(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_MilestoneDetails_Get, request)
  } 
  DIS_Dispatch_Milestone_Get(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_Get, request)
  } 
  DIS_Dispatch_Milestone_Ins(request:any): Observable<any> {
    let pk_dispatchmilestoneId = this.utils.getDecryptedValue(request.pk_dispatchmilestoneId);
    console.log('id', pk_dispatchmilestoneId)
    if(Number(pk_dispatchmilestoneId)>0) {
      return this.http.post(this.api_path.DIS_Dispatch_Milestone_Upd, request)
    } else {
      return this.http.post(this.api_path.DIS_Dispatch_Milestone_Ins, request)
    }
  } 
  DIS_Dispatch_MilestoneDocs_Del(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_MilestoneDocs_Del, request)
  } 
  PMS_CommonDocument_Download(request:any): Observable<any> {
    return this.http.post(this.api_path.PMS_CommonDocument_Download, request)
  } 
  DIS_Dispatch_Milestone_Trn_Del(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_Trn_Del, request)
  }

  DIS_LabPrerequisites_Get(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabPrerequisites_Get, request)
  } 
  DIS_LabItems_Get(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabItems_Get, request)
  } 

  DIS_Dispatch_Milestone_View(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_View, request)
  } 

  DIS_LabType_List(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabType_List, request)
  } 

  DIS_MilestoneFailReason_SelForDDL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_MilestoneFailReason_SelForDDL, request)
  } 

  DIS_LabPrerequisites_Rpt_PDF_EXCEL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabPrerequisites_Rpt_PDF_EXCEL, request)
  } 

  DIS_LabItems_Rpt_PDF_EXCEL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabItems_Rpt_PDF_EXCEL, request)
  } 
  DIS_Dispatch_Milestone_Documents_Get(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_Documents_Get, request)
  } 
  DIS_Dispatch_Milestone_Documents_View(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Dispatch_Milestone_Documents_View, request)
  } 

  DIS_DeliveryChallan_Rpt_PDF_EXCEL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_DeliveryChallan_Rpt_PDF_EXCEL, request)
  } 
  DIS_Lab_Status_Rpt_PDF_EXCEL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Lab_Status_Rpt_PDF_EXCEL, request)
  } 
  DIS_Milestone_Completion_Rpt_PDF_EXCEL(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_Milestone_Completion_Rpt_PDF_EXCEL, request)
  } 



  DIS_LabType_List_HOME(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabType_List_HOME, request)
  } 
  DIS_LabPrerequisites_Get_HOME(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabPrerequisites_Get_HOME, request)
  } 
  DIS_LabItems_Get_HOME(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabItems_Get_HOME, request)
  } 
  DIS_LabPrerequisites_Rpt_PDF_EXCEL_HOME(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabPrerequisites_Rpt_PDF_EXCEL_HOME, request)
  } 
  DIS_LabItems_Rpt_PDF_EXCEL_HOME(request:any): Observable<any> {
    return this.http.post(this.api_path.DIS_LabItems_Rpt_PDF_EXCEL_HOME, request)
  } 

}
